import { RootState } from '@/shared/store'
import { groupsAdapter } from './groupsAdapter'

export const groupsSelectors = groupsAdapter.getSelectors<RootState>(
  (state) => state.groups,
)
